/**
 * Convert an IPv4 address string to a 32-bit unsigned integer.
 *
 * @param ip - IPv4 address (e.g. '192.168.1.1')
 * @returns Unsigned 32-bit integer representation
 */
export const ipToInt = (ip: string): number =>
    ip.split('.').reduce((acc, octet) => (acc << 8) + parseInt(octet, 10), 0) >>> 0
